import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { getFirebaseStorage } from './config';

const ROOM_IMAGES_PATH = 'room-images';

/**
 * Uploads a room image to Firebase Storage.
 * Returns the download URL.
 */
export async function uploadRoomImage(
  roomId: string,
  file: File
): Promise<string> {
  const storage = getFirebaseStorage();
  const extension = file.name.split('.').pop() || 'jpg';
  const path = `${ROOM_IMAGES_PATH}/${roomId}.${extension}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file, {
    contentType: file.type,
  });

  return getDownloadURL(storageRef);
}

/**
 * Deletes a room image from Firebase Storage.
 */
export async function deleteRoomImage(roomId: string): Promise<void> {
  const storage = getFirebaseStorage();
  const extensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

  for (const ext of extensions) {
    try {
      const path = `${ROOM_IMAGES_PATH}/${roomId}.${ext}`;
      const storageRef = ref(storage, path);
      await deleteObject(storageRef);
      return;
    } catch {
      continue;
    }
  }
}

/**
 * Validates an image file before upload.
 */
export function validateImageFile(file: File): string | null {
  const maxSize = 5 * 1024 * 1024;
  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

  if (!allowedTypes.includes(file.type)) {
    return 'File must be an image (JPEG, PNG, GIF, or WebP)';
  }

  if (file.size > maxSize) {
    return 'Image must be less than 5MB';
  }

  return null;
}
